module.exports = require("libphonenumber-js/examples.mobile.json");